/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import Meta from "gatsby-theme-carbon/src/components/Meta";
import LeftNav from "gatsby-theme-carbon/src/components/LeftNav";
import Header from "gatsby-theme-carbon/src/components/Header";
import { Switcher } from "../../components/Switcher";
import Container from "gatsby-theme-carbon/src/components/Container";
import useMetadata from "gatsby-theme-carbon/src/util/hooks/useMetadata";
import Footer from "./Footer";

import "gatsby-theme-carbon/src/styles/index.scss";
import { layout } from "../../styles/Layout.module.scss";

const analyticsConfigScript = `
(function () {
  var isProd = window.location.hostname === 'www.ibm.com';

  window._ibmAnalytics = {
    settings: {
      name: 'ibm-accessibility-able',
      tealiumProfileName: 'in-app-usage-growth',
    },
    onLoad: [['ibmStats.pageview', []]],
  };

  window.digitalData = {
    page: {
      category: {
        primaryCategory: 'NO_CATEGORY_ASSIGNED',
      },
      pageInfo: {
        productTitle: 'IBM Accessibility Website',
        pageID: document.title,
        analytics: {
          category: 'PC030',
        },
        ibm: {
          siteID: 'IBM_ACCESSIBILITY',
        },
        segment: {
          autoPageEventSpa: true, // emit page events on Gatsby client-side route changes
          enabled: true,
          env: isProd ? 'prod' : 'test',
          key: isProd ? '2uSxzka2jCKXuov5LOrFVvDuIlkm6Tog' : 'YTRm1iIGsx9Qu5qRIz8Va71rLFkE4Fj5',
          coremetrics: false,
          commonProperties: {
            productCode: 'A11Y_ABLE',
            productTitle: 'IBM Accessibility Website',
            productCodeType: 'PID',
            instanceId: 'ibm-accessibility-able',
            UT30: '30CDS',
          },
          pageProperties: {
            productCode: 'A11Y_ABLE',
            productTitle: 'IBM Accessibility Website',
            productCodeType: 'PID',
            instanceId: 'ibm-accessibility-able',
            UT30: '30CDS',
          },
        },
      },
    },
  };
})();
`;

const analyticsLoaderScript = `
if (window.location.hostname === 'www.ibm.com') {
  var s1 = document.createElement('script');
  s1.src = '//1.www.s81c.com/common/stats/ibm-common.js';
  s1.type = 'text/javascript';
  s1.async = true;
  document.head.appendChild(s1);

  var s2 = document.createElement('script');
  s2.src = '//1.www.s81c.com/common/carbon/autotrack.min.js';
  s2.type = 'text/javascript';
  s2.async = true;
  document.head.appendChild(s2);
}
`;

const Layout = ({
  children,
  homepage,
  theme,
  titleType,
  pageTitle,
  pageDescription,
  pageKeywords,
  hideNavbar  = false
}) => {
  const is404 = children.key === null;
  const { isSwitcherEnabled } = useMetadata();

  useEffect(() => {
    // eslint-disable-next-line global-require
   require("smooth-scroll")('a[href*="#"]', {
      speed: 400,
      durationMin: 250,
      durationMax: 700,
      easing: "easeInOutCubic",
      clip: true,
      offset: 48,
    });
  }, []);

  return (
    <div className={layout}>
      <Helmet>
        <script type="text/javascript">{analyticsConfigScript}</script>
        <script type="text/javascript">{analyticsLoaderScript}</script>
      </Helmet>
      <Meta
        titleType={titleType}
        pageTitle={pageTitle}
        pageDescription={pageDescription}
        pageKeywords={pageKeywords}
      />
      <Header isSwitcherEnabled={isSwitcherEnabled} />
      {isSwitcherEnabled && <Switcher />}
      <Container homepage={homepage} theme={theme}>
        <main>
        {!hideNavbar && <LeftNav homepage={homepage} is404Page={is404} theme={theme} />}
          <div  id="main-content">
            {children}
          </div>
          </main>
        <Footer />
      </Container>
    </div>
  );
};

export default Layout;
